import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  NavController,
  ViewController,
  LoadingController,
  AlertController,
  PopoverController,
  NavParams,
} from "ionic-angular";
import { FormBuilder } from "@angular/forms";
import { Subscription } from "rxjs";
import * as moment from "moment";

import { JobsProvider } from "../../providers/jobs/jobs";
import { StaffProvider } from "../../providers/staff/staff";
import { AuthProvider } from "./../../providers/auth/auth";
import { NotificationsProvider } from "./../../providers/notifications/notifications";
import { RatingsProvider } from "../../providers/ratings/ratings";

import { IJobStaff, IJob, JobStatus } from "../../interfaces/jobs";
import { IStaffType } from "./../../interfaces/staff";
import { IUser } from "../../interfaces/users";
import { INotification } from "../../interfaces/notifications";
import { IRating } from "../../interfaces/ratings";

@Component({
  selector: "user-info",
  templateUrl: "user-info.html",
})
export class UserInfoComponent implements OnInit, OnDestroy {
  candidate: IJobStaff;
  job: IJob;
  currentUser: IUser;
  user: IUser;
  userSubscription: Subscription;
  userDataLoaded = false;

  jobStaff: IJobStaff[] = [];
  jobStaffSubscription: Subscription;

  ratings: IRating[] = [];
  ratingsSubscription: Subscription;
  ratingsDataLoaded = false;
  ratingAverage = 0;
  ratingStaffTypes: IStaffType[] = [];
  ratingStaffTypesDataLoaded = false;

  staffTypes: IStaffType[] = [];
  staffTypesSubscription: Subscription;

  canAccept: boolean;
  showAccept = true;
  showDecline = true;

  skillsRating = 0;
  overallRating = 0;

  constructor(
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public popoverCtrl: PopoverController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private jobsProvider: JobsProvider,
    private staffProvider: StaffProvider,
    private authProvider: AuthProvider,
    private ratingsProvider: RatingsProvider,
    private notificationsProvider: NotificationsProvider
  ) {
    this.candidate = this.navParams.data.candidate;
    this.job = this.navParams.data.job;
    this.currentUser = this.navParams.data.user;
  }

  ngOnInit() {
    console.log(this.candidate);
    console.log("job info from UserInfoComponent");
    console.log(this.job);

    this.loadUserInfo();
    this.loadJobStaff();
    this.loadUserRatings(this.candidate.userId);
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.jobStaffSubscription) {
      this.jobStaffSubscription.unsubscribe();
    }
    if (this.ratingsSubscription) {
      this.ratingsSubscription.unsubscribe();
    }
    if (this.staffTypesSubscription) {
      this.staffTypesSubscription.unsubscribe();
    }
  }

  loadJobStaff() {
    this.jobStaffSubscription = this.jobsProvider
      .getJobStaff(this.job.id)
      .subscribe(
        (data) => {
          this.jobStaff = data;

          let requiredApplications = this.job.staff.find(
            (j) => j.staffType.id === this.candidate.applicationType.id
          );
          console.log("required staff of this applicationType");
          console.log(requiredApplications);

          let confirmedApplications = this.jobStaff
            .filter((js) => js.status === 1)
            .filter(
              (js) =>
                js.applicationType.id === this.candidate.applicationType.id
            );
          console.log(confirmedApplications);

          if (confirmedApplications.length === requiredApplications.quantity) {
            console.log(
              `we have enough ${requiredApplications.staffType.title}`
            );
            this.canAccept = false;
          } else {
            console.log(
              `we don't have enough ${requiredApplications.staffType.title}`
            );
            this.canAccept = true;
          }

          if (
            moment().isSameOrAfter(
              moment(this.job.start).subtract(30, "minute")
            ) ||
            this.job.status === JobStatus.Started ||
            this.job.status === JobStatus.Cancelled ||
            this.job.status === JobStatus.Ended
          ) {
            this.showAccept = false;
            this.showDecline = false;
          }

          return data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  loadUserInfo() {
    this.userSubscription = this.authProvider
      .getUserByUid(this.candidate.userId)
      .subscribe(
        (data) => {
          // console.log(user);
          this.user = data;
          this.userDataLoaded = true;
          return data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  loadUserRatings(uid: string) {
    this.ratingsSubscription = this.ratingsProvider
      .getUserRatings(uid)
      .subscribe(
        async (data) => {
          console.log(data);

          let total = 0;
          if (data) {
            total = data.length * 5;
          }
          console.log(`total: ${total}`);

          let score = 0;
          data.forEach((r) => {
            score = score + r.rating;
          });
          console.log(`score: ${score}`);


          if (total === 0 && score === 0) {
            console.log(`raw average: 0`);
            this.ratingAverage = 0;
          } else {
            console.log(`raw average: ${(score / total) * 5}`);
            this.ratingAverage = Math.round((score / total) * 5);
          }
          console.log(`rounded average: ${this.ratingAverage}`);

          this.populateRatingStaffTypes(
            Array.from(
              new Set(data.map((rating: IRating) => rating.staffTypeId))
            )
          );

          if (await this.ratingsProvider.getUserSkillsRatingsPromise(uid)) {
            this.skillsRating = await (
              await this.ratingsProvider.getUserSkillsRatingsPromise(uid)
            ).overallRating;
          } else {
            this.skillsRating = 0;
          }
          console.log("skillsRating", this.skillsRating);
          console.log("staffrating", this.ratingAverage);

          this.overallRating = (this.skillsRating + this.ratingAverage) / 2;

          this.ratingsDataLoaded = true;
          return data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  populateRatingStaffTypes(ratingStaffTypes: string[]) {
    console.log(ratingStaffTypes);
    this.staffTypesSubscription = this.staffProvider.getStaffTypes().subscribe(
      (data) => {
        console.log(data);

        ratingStaffTypes.forEach((rst) => {
          let newRatingStaffType = data.find((st) => st.id === rst);
          this.ratingStaffTypes.push(newRatingStaffType);
        });
        console.log(this.ratingStaffTypes);
        this.ratingStaffTypesDataLoaded = true;
        return data;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  declineStaff(jobId: string, userId: string) {
    let loader = this.loadingCtrl.create({
      content: "Declining application...",
    });
    loader.present();

    this.jobsProvider
      .updateJobApplication(jobId, userId, 2)
      .then(() => {
        let notification: INotification = {
          title: "Application declined",
          message: `Your application for ${
            this.candidate.applicationType.title
          } at ${this.job.name} - ${this.job.address.line2}, ${
            this.job.address.city
          } on ${moment(this.job.start).format(
            "Do MMMM YYYY"
          )} has been declined.`,
          icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
          component: "job",
          item: jobId,
          status: 0,
        };
        this.notificationsProvider
          .createNotification(userId, notification)
          .then(() => {
            loader.dismiss();
            this.close();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  acceptStaff(jobId: string, userId: string) {
    let loader = this.loadingCtrl.create({
      content: "Accepting application...",
    });
    loader.present();

    this.jobsProvider
      .updateJobApplication(jobId, userId, 1)
      .then(() => {
        let notification: INotification = {
          title: "Application accepted",
          message: `Your application for ${
            this.candidate.applicationType.title
          } at ${this.job.name} - ${this.job.address.line2}, ${
            this.job.address.city
          } on ${moment(this.job.start).format(
            "Do MMMM YYYY"
          )} has been accepted!`,
          icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
          component: "job",
          item: jobId,
          status: 0,
        };
        this.notificationsProvider
          .createNotification(userId, notification)
          .then(() => {
            loader.dismiss();
            this.close();
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  confirmClockIn(candidate: IJobStaff) {
    let loader = this.loadingCtrl.create({
      content: "Clocking in...",
    });
    loader.present();
    console.log(
      `going to clock in user: ${candidate.userId} to job: ${this.job.id}`
    );
    this.jobsProvider
      .updateJobApplication(this.job.id, candidate.userId, 4)
      .then(() => {
        console.log("Staff Clocked In");

        const notification: INotification = {
          title: "Clocked in",
          message: `${this.currentUser.firstName} ${this.currentUser.lastName} has confirmed your clock in.`,
          icon: `https://firebasestorage.googleapis.com/v0/b/jbx-app.appspot.com/o/assets%2Flogos%2Fjbx-logo.png?alt=media&token=6fab7457-194e-4916-9c91-69cfe6e4cb8d`,
          component: "job",
          item: this.job.id,
          status: 0,
        };

        this.notificationsProvider.createNotification(
          candidate.userId,
          notification
        );

        loader.dismiss();
      });
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/shared/user/user-info.ts